import * as THREE from 'three';
import { Annotation } from '../Annotation';
import { EventDispatcher } from '../EventDispatcher';
import { Utils } from '../utils';

/** Minimal Potree viewer interface used by AnnotationTool */
interface PotreeViewer {
  renderer: THREE.WebGLRenderer;
  scene: {
    annotations: { add(a: Annotation): void; remove(a: Annotation): void };
    scene: THREE.Scene;
    getActiveCamera(): THREE.Camera;
    pointclouds: unknown[];
  };
  inputHandler: {
    startDragging(obj: THREE.Object3D): void;
  };
}

/** Drag event from Potree input handler */
interface DragEvent {
  drag: { end: { x: number; y: number } };
  viewer: PotreeViewer;
}

export class AnnotationTool extends EventDispatcher {
  viewer: PotreeViewer;
  renderer: THREE.WebGLRenderer;

  sg: THREE.SphereGeometry;
  sm: THREE.MeshNormalMaterial;
  s: THREE.Mesh;

  constructor(viewer: PotreeViewer) {
    super();

    this.viewer = viewer;
    this.renderer = viewer.renderer;

    this.sg = new THREE.SphereGeometry(0.1);
    this.sm = new THREE.MeshNormalMaterial();
    this.s = new THREE.Mesh(this.sg, this.sm);
  }

  startInsertion(_args: Record<string, unknown> = {}) {
    const domElement = this.viewer.renderer.domElement;

    const annotation = new Annotation({
      position: [589748.27, 231444.54, 753.675],
      title: 'Annotation Title',
      description: `Annotation Description`,
    });
    this.dispatchEvent({ type: 'start_inserting_annotation', annotation: annotation });

    const annotations = this.viewer.scene.annotations;
    annotations.add(annotation);

    const callbacks: {
      cancel: ((e?: MouseEvent) => void) | null;
      finish: ((e?: MouseEvent) => void) | null;
    } = {
      cancel: null,
      finish: null,
    };

    const insertionCallback = (e: MouseEvent) => {
      if (e.button === THREE.MOUSE.LEFT) {
        callbacks.finish?.(e);
      } else if (e.button === THREE.MOUSE.RIGHT) {
        callbacks.cancel?.(e);
      }
    };

    callbacks.cancel = () => {
      annotations.remove(annotation);

      domElement.removeEventListener('mouseup', insertionCallback, true);
    };

    callbacks.finish = () => {
      domElement.removeEventListener('mouseup', insertionCallback, true);
    };

    domElement.addEventListener('mouseup', insertionCallback, true);

    const drag = (e: DragEvent) => {
      const I = Utils.getMousePointCloudIntersection(
        e.drag.end,
        e.viewer.scene.getActiveCamera(),
        e.viewer as unknown as Parameters<typeof Utils.getMousePointCloudIntersection>[2],
        e.viewer.scene.pointclouds as unknown as Parameters<typeof Utils.getMousePointCloudIntersection>[3],
        { pickClipped: false },
      );

      if (I && !Array.isArray(I) && 'location' in I) {
        this.s.position.copy(I.location);

        if (annotation.position) {
          annotation.position.copy(I.location);
        }
      }
    };

    const drop = () => {
      this.viewer.scene.scene.remove(this.s);
      // @ts-expect-error - Potree uses custom event system on THREE.Mesh
      this.s.removeEventListener('drag', drag);
      // @ts-expect-error - Potree uses custom event system on THREE.Mesh
      this.s.removeEventListener('drop', drop);
    };

    // @ts-expect-error - Potree uses custom event system on THREE.Mesh
    this.s.addEventListener('drag', drag);
    // @ts-expect-error - Potree uses custom event system on THREE.Mesh
    this.s.addEventListener('drop', drop);

    this.viewer.scene.scene.add(this.s);
    this.viewer.inputHandler.startDragging(this.s);

    return annotation;
  }

  update() {
    // let camera = this.viewer.scene.getActiveCamera();
    // let domElement = this.renderer.domElement;
    // let measurements = this.viewer.scene.measurements;
    // const renderAreaSize = this.renderer.getSize(new THREE.Vector2());
    // let clientWidth = renderAreaSize.width;
    // let clientHeight = renderAreaSize.height;
  }

  render() {
    //this.viewer.renderer.render(this.scene, this.viewer.scene.getActiveCamera());
  }
}
